import Swiper from 'swiper';
import { videoPlayerHandler } from '../helpers/helpers';

// Video + 2up carousel sliders
const init = function(swiperId) {
  const swiperElement = document.querySelector(swiperId);
  const videoSwiper = new Swiper(swiperId, {
    slidesPerView: 1,
    speed: 500,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.js-swiper-button-next',
      prevEl: '.js-swiper-button-prev',
    },
    on: {
      slideChangeTransitionStart: () => {
        const height = swiperElement.clientHeight;
        swiperElement.style.height = `${height}px`;
      },
      slideChangeTransitionEnd: () => {
        swiperElement.style.height = '';
      },
      slideChange: () => {
        const swiper2Up = document.querySelector('.js-swiper-2up'),
          swiperVideos = document.querySelector('.js-swiper-videos');
        if (swiperVideos && swiper2Up) {
          swiper2Up.swiper.slideTo(swiperVideos.swiper.activeIndex);
        }

        videoPlayerHandler(swiperId);
      },
    },
  });
  const twoUpSwiper = new Swiper('.js-swiper-2up', {
    grabCursor: false,
    centeredSlides: true,
    slidesPerView: 'auto',
    initialSlide: 1,
    allowTouchMove: false,
    keyboard: {
      enabled: true,
    },
    spaceBetween: 20,
    pagination: {
      el: '.js-swiper-2up-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.js-swiper-2up-button-next',
      prevEl: '.js-swiper-2up-button-prev',
    },
    on: {
      slideChangeTransitionStart() {
        const height = swiperElement.clientHeight;
        swiperElement.style.height = `${height}px`;
      },
      slideChangeTransitionEnd() {
        swiperElement.style.height = '';
      },
      slideChange() {
        document
          .querySelector('.js-swiper-videos')
          .swiper.slideTo(
            document.querySelector('.js-swiper-2up').swiper.activeIndex
          );
      },
    },
  });
};

export default {
  init,
};
